import { PlateElementProps } from '@udecode/plate/react';
import { cn } from '@/lib/utils';

// Define the media embed element type
interface TMediaEmbedElement {
  type: 'media_embed';
  url: string;
  source?: string;
  alt?: string;
  caption?: string;
  width?: number;
  height?: number;
  children: { text: string }[];
}

export function MediaEmbedElement({
  className,
  children,
  element,
}: PlateElementProps) {
  const { url, caption, alt, source } = element as unknown as TMediaEmbedElement;

  return (
    <div className={cn('relative my-4', className)} contentEditable={false}>
      <div className="relative group">
        <div className="w-full overflow-hidden rounded-md">
          <iframe
            src={url}
            className="w-full aspect-video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title={alt || caption || 'Embedded media'}
          />
        </div>
        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-opacity rounded-md" />
      </div>
      {caption && (
        <div className="text-sm text-gray-500 mt-1 text-center">{caption}</div>
      )}
      {source && (
        <div className="text-xs text-gray-400 mt-1 text-center">
          Source: {source}
        </div>
      )}
      {children}
    </div>
  );
}
